<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">Add Camp Sub Type</span>
      <span v-else>Edit Camp Sub Type </span>
    </h1>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col sm="6" cols="12" class="align-self-center">
            <section class="file-upload">
              <new-image-upload
                class="file-upload__image"
                :imgUrl="form.mini_photo ? form.mini_photo.path : ''"
                :imgId="form.mini_photo ? form.mini_photo.id : ''"
                @fileSelected="profileChange"
                fieldName="mainImgFile"
                :maxSize="maxSize"
                :height="320"
                :width="320"
                :reset="resetBoolean"
              />
              <p class="my-2 gray">
                <small
                  >Upload Sub Type Image <br />
                  Should be (320 * 320)</small
                >
              </p>
              <template v-if="form.mini_photo != null">
                <a
                  :href="form.mini_photo"
                  target="_blank"
                  v-if="isEdited === true && logoBoolean"
                  class="mt-8"
                >
                  show image
                </a>
              </template>
            </section>
          </v-col>
          <v-col sm="6" cols="12" class="align-self-center">
            <section class="file-upload">
              <new-image-upload
                class="file-upload__image"
                :imgUrl="form.photo ? form.photo.path : ''"
                :imgId="form.photo ? form.photo.id : ''"
                @fileSelected="photoChange"
                fieldName="mainPhotoFile"
                :maxSize="maxSize"
                :reset="resetBoolean"
              />
              <p class="my-2 gray">
                <small
                  >Upload Sub Type Header<br />
                  Should be (1688 * 765)</small
                >
              </p>
              <template v-if="form.photo != null">
                <a
                  :href="form.photo"
                  target="_blank"
                  v-if="isEdited === true && photoBoolean"
                  class="mt-8"
                >
                  show image
                </a>
              </template>
            </section>
          </v-col>
          <v-col class="py-2" sm="6" cols="12">
            <v-text-field
              label="Name"
              regular
              v-model.trim="form.name"
              type="text"
            >
            </v-text-field>
          </v-col>
          <v-col sm="6" cols="12" class="py-2">
            <section class="increment-label">
              <span>Order</span>
              <number-input
                center
                v-model="form.order"
                :min="1"
                :step="1"
                controls
              ></number-input>
            </section>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-textarea
              label="Short Description"
              regular
              rows="3"
              v-model.trim="form.description"
            ></v-textarea>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-textarea
              label="Description"
              regular
              v-model.trim="form.long_description"
            ></v-textarea>
          </v-col>
          <v-col class="py-2" cols="12">
            <form-group name="subject" :attribute="`fields.subject`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.subject"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col sm="6" cols="12" class="align-self-center">
                <section class="file-upload">
                  <new-image-upload
                    class="file-upload__image"
                    :imgUrl="
                      form.section_1_photo ? form.section_1_photo.path : ''
                    "
                    :imgId="form.section_1_photo ? form.section_1_photo.id : ''"
                    @fileSelected="firstSectionChange"
                    fieldName="mainImgFile"
                    :maxSize="maxSize"
                    :width="320"
                    :height="320"
                    :reset="resetBoolean"
                  />
                  <p class="my-2 gray">
                    <small> Should be (320 * 320)</small>
                  </p>
                  <template v-if="form.section_1_photo != null">
                    <a
                      :href="form.section_1_photo"
                      target="_blank"
                      v-if="isEdited === true && sectionOneBoolean"
                      class="mt-8"
                    >
                      show image
                    </a>
                  </template>
                </section>
              </v-col>
              <v-col class="py-2" cols="12" sm="6">
                <form-group
                  name="section_1_header"
                  :attribute="`fields.section_1_header`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      label="Title"
                      v-model.trim="form.section_1_header"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12">
                <vue-editor v-model="form.section_1_description"></vue-editor>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="6" cols="12" class="align-self-center">
                <section class="file-upload">
                  <new-image-upload
                    class="file-upload__image"
                    :imgUrl="
                      form.section_2_photo ? form.section_2_photo.path : ''
                    "
                    :imgId="form.section_2_photo ? form.section_2_photo.id : ''"
                    @fileSelected="secondSectionChange"
                    fieldName="mainImgFile"
                    :maxSize="maxSize"
                    :width="320"
                    :height="320"
                    :reset="resetBoolean"
                  />
                  <p class="my-2 gray">
                    <small> Should be (320 * 320)</small>
                  </p>
                  <template v-if="form.section_2_photo != null">
                    <a
                      :href="form.section_2_photo"
                      target="_blank"
                      v-if="isEdited === true && sectionTwoBoolean"
                      class="mt-8"
                    >
                      show image
                    </a>
                  </template>
                </section>
              </v-col>
              <v-col class="py-2" cols="12" sm="6">
                <form-group
                  name="section_2_header"
                  :attribute="`fields.section_2_header`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      label="Title"
                      v-model.trim="form.section_2_header"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12">
                <vue-editor v-model="form.section_2_description"></vue-editor>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="6" cols="12" class="align-self-center">
                <section class="file-upload">
                  <new-image-upload
                    class="file-upload__image"
                    :imgUrl="
                      form.section_3_photo ? form.section_3_photo.path : ''
                    "
                    :imgId="form.section_3_photo ? form.section_3_photo.id : ''"
                    @fileSelected="thirdSectionChange"
                    fieldName="mainImgFile"
                    :maxSize="maxSize"
                    :width="320"
                    :height="320"
                    :reset="resetBoolean"
                  />
                  <p class="my-2 gray">
                    <small> Should be (320 * 320)</small>
                  </p>
                  <template v-if="form.section_3_photo != null">
                    <a
                      :href="form.section_3_photo"
                      target="_blank"
                      v-if="isEdited === true && sectionThreeBoolean"
                      class="mt-8"
                    >
                      show image
                    </a>
                  </template>
                </section>
              </v-col>
              <v-col class="py-2" cols="12" sm="6">
                <form-group
                  name="section_3_header"
                  :attribute="`fields.section_3_header`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      label="Title"
                      v-model.trim="form.section_3_header"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12">
                <vue-editor v-model="form.section_3_description"></vue-editor>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="6" cols="12" class="align-self-center">
                <section class="file-upload">
                  <new-image-upload
                    class="file-upload__image"
                    :imgUrl="
                      form.section_4_photo ? form.section_4_photo.path : ''
                    "
                    :imgId="form.section_4_photo ? form.section_4_photo.id : ''"
                    @fileSelected="forthSectionChange"
                    fieldName="mainImgFile"
                    :maxSize="maxSize"
                    :width="320"
                    :height="320"
                    :reset="resetBoolean"
                  />
                  <p class="my-2 gray">
                    <small> Should be (320 * 320)</small>
                  </p>
                  <template v-if="form.section_4_photo != null">
                    <a
                      :href="form.section_4_photo"
                      target="_blank"
                      v-if="isEdited === true && sectionFourBoolean"
                      class="mt-8"
                    >
                      show image
                    </a>
                  </template>
                </section>
              </v-col>
              <v-col class="py-2" cols="12" sm="6">
                <form-group
                  name="section_4_header"
                  :attribute="`fields.section_4_header`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      label="Title"
                      v-model.trim="form.section_4_header"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12">
                <vue-editor v-model="form.section_4_description"></vue-editor>
              </v-col>
            </v-row>
          </v-col>
          <v-col sm="6" class="py-0">
            <section class="transparent-field h-40">
              <v-switch
                class="mt-0"
                :true-value="1"
                :false-value="0"
                v-model="form.on_website"
                label="Appear in website ?"
              ></v-switch>
            </section>
          </v-col>
          <!-- <v-col cols="12">
            <vue-editor v-model="form.section_5_description"></vue-editor>
          </v-col> -->
          <v-col cols="12">
            <v-btn
              class="success text-capitalize"
              large
              type="submit"
              width="30%"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";
// import { required, maxLength } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";
export default {
  data() {
    return {
      form: {
        name: "",
        order: "",
        photo: "",
        mini_photo: "",
        section_1_header: "",
        section_2_header: "",
        section_3_header: "",
        section_4_header: "",
      },
      maxSize: 2.048,
      resetLogo: false,
      Logo: false,
      Photo: false,
      stopTime: false,
      returnTime: false,
      isEdited: false,
      loadingData: false,
      globalServerErrors: null,
      logoBoolean: true,
      sectionOneBoolean: true,
      sectionTwoBoolean: true,
      sectionThreeBoolean: true,
      sectionFourBoolean: true,
      photoBoolean: true,
      resetBoolean: false,
      logoChange: false,
      sectionOneChange: false,
      sectionTwoChange: false,
      sectionThreeChange: false,
      sectionFourChange: false,
      photoChangeBoolean: false,
    };
  },
  created() {
    this.editCreateBoolean();
  },
  components: {
    VueEditor,
  },
  methods: {
    handleSave() {
      if (!this.isEdited) {
        this.createLocation();
      } else {
        this.editBusStop();
      }
    },
    editCreateBoolean() {
      if (this.$route.name != "CampsSubTypesCreate") {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `camp-types/${this.$route.params.id}/sub-types`,
        id: id,
      })
        .then((res) => {
          const { sub_type } = res.data;
          this.form = sub_type;
        })
        .catch(() => {});
    },
    createLocation() {
      const formData = new FormData();
      Object.keys(this.form).forEach((formItem) => {
        formData.append(formItem, this.form[formItem]);
      });
      StoreData({
        reqName: `camp-types/${this.$route.params.id}/sub-types`,
        data: formData,
      })
        .then(() => {
          history.go(-1);
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editBusStop() {
      const formData = new FormData();
      if (!this.logoChange) {
        delete this.form.mini_photo;
      }
      if (!this.sectionOneChange) {
        delete this.form.section_1_photo;
      }
      if (!this.sectionTwoChange) {
        delete this.form.section_2_photo;
      }
      if (!this.sectionThreeChange) {
        delete this.form.section_3_photo;
      }
      if (!this.sectionFourChange) {
        delete this.form.section_4_photo;
      }
      if (!this.photoChangeBoolean) {
        delete this.form.photo;
      }
      Object.keys(this.form).forEach((formItem) => {
        console.log(typeof this.form[formItem], formItem);

        if (formItem === "country") {
          formData.append(formItem, this.form[formItem].id);
        } else {
          if (this.form[formItem] != null) {
            formData.append(formItem, this.form[formItem]);
          }
        }
      });
      // if (this.form.photo == null) {
      //   formData.append(this.form.photo, "");
      // }
      formData.append("_method", "put");
      UpdateData({
        reqName: `camp-types/${this.$route.params.id}/sub-types`,
        data: formData,
        id: this.$route.params.slug,
      })
        .then(() => {
          this.isEdited = false;
          history.go(-1);

          this.reset();
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    profileChange(photo) {
      this.form.mini_photo = photo.file;
      this.logoBoolean = false;
      this.resetBoolean = false;
      this.logoChange = true;
    },
    firstSectionChange(photo) {
      this.form.section_1_photo = photo.file;
      this.sectionOneBoolean = false;
      this.resetBoolean = false;
      this.sectionOneChange = true;
    },
    secondSectionChange(photo) {
      this.form.section_2_photo = photo.file;
      this.sectionTwoBoolean = false;
      this.resetBoolean = false;
      this.sectionTwoChange = true;
    },
    thirdSectionChange(photo) {
      this.form.section_3_photo = photo.file;
      this.sectionThreeBoolean = false;
      this.resetBoolean = false;
      this.sectionThreeChange = true;
    },
    forthSectionChange(photo) {
      this.form.section_4_photo = photo.file;
      this.sectionFourBoolean = false;
      this.resetBoolean = false;
      this.sectionFourChange = true;
    },
    photoChange(photo) {
      this.form.photo = photo.file;
      this.photoBoolean = false;
      this.resetBoolean = false;
      this.photoChangeBoolean = true;
    },
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "CampsSubTypesEdit") {
          this.$nextTick(() => {
            this.showData(route.params.slug);
            console.log(route);
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  validations: {
    // form: {
    //   name: {
    //     required,
    //     maxLength: maxLength(190)
    //   },
    //   description: {
    //     required
    //   },
    //   long_description: {
    //     required
    //   }
    // }
  },
};
</script>
